<div class="container" [class.closed]="closed" [class.electron]="isElectron">
  <div class="header">
    <div>
      Changelog
    </div>
    <button class="close-button" (click)="close()"><i class="fas fa-times"></i></button>
  </div>
  <div class="log mono" #log>
    <p *ngFor="let entry of logEntries; index as i" [innerHTML]="entry" class="log-entry" [class.secondary]="(i) % 2 === 1"></p>
  </div>
</div>
<audio src="assets/notification.ogg" preload="none" #sound></audio>
